import _objectSpread from "E:\\xinyongban\\xinyidai-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/objectSpread";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:\\xinyongban\\xinyidai-frontend\\node_modules\\@babel\\runtime-corejs2/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { selectList, addWhiteList, modWhiteList, delWhiteList } from '@/api/whiteList';
export default {
  props: {
    getSourceType: String
  },
  data: function data() {
    var checkPhone = function checkPhone(rule, value, callback) {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        var reg = /^1[3|4|5|7|8][0-9]\d{8}$/;

        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };

    return {
      bankTitle: '',
      dialogUpload: false,
      rules: {
        phone: [{
          validator: checkPhone,
          required: true,
          trigger: "blur"
        }],
        sourceType: [{
          required: true,
          message: "请输入来源",
          trigger: "blur"
        }]
      },
      sourceTypeList: [// { label: "企业", value: 1 },
      {
        label: "银行",
        value: '2'
      }, {
        label: "审核人",
        value: '3'
      }, {
        label: "监管",
        value: '4'
      }],
      modeUploadForm: {
        id: '',
        phone: "",
        sourceType: "",
        remark: ""
      },
      form: {
        phone: '',
        //手机号
        userName: '',
        //用户名
        status: '',
        //状态精确匹配：1 启用 / 0 禁用
        sourceType: '',
        //账号类型精确匹配：1 企业 / 2 银行
        page: 1,
        pageSize: 10
      },
      applyProList: [],
      total: 0
    };
  },
  created: function created() {
    this.getcheckinListList();
  },
  methods: {
    deletUpload: function deletUpload(row) {
      var _this = this;

      this.$confirm('是否删除该条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        delWhiteList({
          id: row.id
        }).then(function (res) {
          if (res.data.code == 200) {
            _this.$message.success(res.data.msg);

            _this.getcheckinListList();
          } else {
            _this.$message.error(res.data.msg);
          }
        });
      }).catch(function () {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    submitUpload: function submitUpload() {
      var _this2 = this;

      this.$refs.formRef.validate(function (valid) {
        if (valid) {
          if (_this2.bankTitle == '编辑') {
            modWhiteList(_this2.modeUploadForm).then(function (res) {
              if (res.data.code == 200) {
                _this2.$message.success(res.data.msg);

                _this2.handleCloseDialog();

                _this2.getcheckinListList();
              } else {
                _this2.$message.error(res.data.msg);
              }
            });
          } else if (_this2.bankTitle == '新建') {
            addWhiteList(_this2.modeUploadForm).then(function (res) {
              if (res.data.code == 200) {
                _this2.$message.success(res.data.msg);

                _this2.handleCloseDialog();

                _this2.getcheckinListList();
              } else {
                _this2.$message.error(res.data.msg);
              }
            });
          }
        }
      });
    },
    handleCloseDialog: function handleCloseDialog() {
      this.modeUploadForm = {
        id: '',
        phone: "",
        sourceType: "",
        remark: ""
      };
      this.dialogUpload = false;
    },
    editUpload: function editUpload(row, type) {
      this.bankTitle = type;

      if (type == '新建') {
        this.modeUploadForm = {
          phone: "",
          sourceType: "",
          remark: ""
        };
      } else if (type == '编辑') {
        this.modeUploadForm = {
          id: row.id ? row.id : '',
          phone: row.phone ? row.phone : '',
          sourceType: row.sourceType ? row.sourceType : '',
          remark: row.remark ? row.remark : ''
        };
      }

      this.dialogUpload = true;
    },
    getBankStatus: function getBankStatus(num, row) {
      if (row.bankList[num] && row.bankList[num].reqStatus != null) {
        return row.bankList[num].reqStatus;
      } else {
        return '-';
      }
    },
    // 查询
    queryInfo: function queryInfo() {
      this.form.page = 1;
      this.getcheckinListList();
    },
    getcheckinListList: function () {
      var _getcheckinListList = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        var searchForm;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                searchForm = _objectSpread({}, this.form);
                selectList(searchForm).then(function (res) {
                  if (res.data.code == 200) {
                    _this3.applyProList = res.data.data.list;
                    _this3.total = res.data.data.total;
                  } else {
                    _this3.$message.error(res.data.msg);
                  }
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getcheckinListList() {
        return _getcheckinListList.apply(this, arguments);
      }

      return getcheckinListList;
    }(),
    handleCurrentChange: function handleCurrentChange(val) {
      this.form.page = val;
      this.getcheckinListList();
    }
  }
};